import React, { useState } from 'react';
import { ClipboardList, FileText, Minus, Plus, Trash2, X, ChevronDown, ChevronUp } from 'lucide-react';
import { partById } from '../data/ul101Parts';
import { trackEvent } from '../lib/analytics';
export { useQuoteList } from '../lib/quoteList';

export const buildPartsMessage = (list) => {
  const lines = Object.entries(list).map(([pn, qty]) => { const p = partById(pn); return p ? `- P/N ${pn} ${p.name} × ${qty}` : null; }).filter(Boolean);
  return `Replacement parts request — CTRL UL101 Aviation Troubleshooter (B00033 / SPL-1473)\n${lines.join('\n')}\n\nShip-to / notes: `;
};

export const UL101QuoteTray = ({ list, setQty, clear, onRequestQuote }) => {
  const [openTray, setOpenTray] = useState(true);
  const entries = Object.entries(list);
  const count = entries.reduce((s, [, q]) => s + q, 0);
  if (!entries.length) return null;

  const submit = () => {
    trackEvent('parts_list_quote', { product: 'UL101', resource: `parts-${entries.length}` });
    onRequestQuote?.({ product: 'UL101', resource: 'parts-list', prefill: { product: 'UL101', message: buildPartsMessage(list) } });
  };

  return (
    <div className="fixed z-40 bottom-20 sm:bottom-6 left-3 right-3 sm:left-6 sm:right-auto sm:w-[420px] rounded-2xl bg-[#1e2d3b] text-white shadow-2xl ring-1 ring-white/10 animate-fade-in" data-testid="ul101-quote-tray">
      <div className="flex items-center gap-3 px-4 py-3">
        <ClipboardList className="h-5 w-5 text-orange-400 flex-shrink-0" aria-hidden="true" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold leading-tight" data-testid="ul101-quote-tray-summary">{entries.length} part{entries.length === 1 ? '' : 's'} · {count} item{count === 1 ? '' : 's'}</p>
          <p className="text-[11px] text-slate-300">One quote request for everything below</p>
        </div>
        <button type="button" onClick={() => setOpenTray((o) => !o)} className="rounded-full p-1.5 text-slate-300 hover:bg-white/10 hover:text-white transition-colors" aria-label={openTray ? 'Collapse parts list' : 'Expand parts list'} data-testid="ul101-quote-tray-toggle">
          {openTray ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
        </button>
        <button type="button" onClick={clear} className="rounded-full p-1.5 text-slate-300 hover:bg-white/10 hover:text-white transition-colors" aria-label="Clear parts list" data-testid="ul101-quote-tray-clear">
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
      {openTray && (
        <ul className="max-h-56 overflow-y-auto border-t border-white/10 divide-y divide-white/5" data-testid="ul101-quote-tray-items">
          {entries.map(([pn, qty]) => {
            const p = partById(pn);
            if (!p) return null;
            return (
              <li key={pn} className="flex items-center gap-3 px-4 py-2" data-testid={`ul101-quote-tray-item-${pn}`}>
                <span className="font-mono text-[11px] text-orange-300 w-14 flex-shrink-0">{pn}</span>
                <span className="flex-1 min-w-0 truncate text-xs">{p.name}</span>
                <span className="inline-flex items-center rounded-full bg-white/10">
                  <button type="button" onClick={() => setQty(pn, qty - 1)} className="p-1.5 hover:text-orange-300 transition-colors" aria-label={`Decrease quantity of ${p.name}`} data-testid={`ul101-quote-tray-dec-${pn}`}><Minus className="h-3 w-3" /></button>
                  <span className="w-5 text-center text-xs font-bold tabular-nums" data-testid={`ul101-quote-tray-qty-${pn}`}>{qty}</span>
                  <button type="button" onClick={() => setQty(pn, qty + 1)} className="p-1.5 hover:text-orange-300 transition-colors" aria-label={`Increase quantity of ${p.name}`} data-testid={`ul101-quote-tray-inc-${pn}`}><Plus className="h-3 w-3" /></button>
                </span>
                <button type="button" onClick={() => setQty(pn, 0)} className="p-1 text-slate-400 hover:text-white transition-colors" aria-label={`Remove ${p.name}`} data-testid={`ul101-quote-tray-remove-${pn}`}><X className="h-3.5 w-3.5" /></button>
              </li>
            );
          })}
        </ul>
      )}
      <div className="p-3 border-t border-white/10">
        <button type="button" onClick={submit} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-orange-500 px-4 py-2.5 text-sm font-semibold text-white hover:bg-orange-600 transition-colors" data-testid="ul101-quote-tray-submit">
          <FileText className="h-4 w-4" /> Request one quote for {entries.length} part{entries.length === 1 ? '' : 's'}
        </button>
      </div>
    </div>
  );
};
